import { create } from "zustand"

type SurveyStoreData = {
  hasSurveyBeenTriggered: boolean
  markSurveyAsTriggered: () => void
}

const useSurveyStore = create<SurveyStoreData>((set) => ({
  hasSurveyBeenTriggered: false,
  markSurveyAsTriggered: () => set({ hasSurveyBeenTriggered: true }),
}))

export default useSurveyStore
